import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { scrollToCheckout } from '../lib/data';
export function StickyBar() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  if (!show) return null;
  return <div className="fixed inset-x-0 bottom-0 z-30 border-t border-white/10 bg-hockey-ink/95 px-3 py-2.5 backdrop-blur" data-id="element-207" data-mp="nuhzxckjrtfj">
      <button type="button" onClick={scrollToCheckout} className="flex w-full items-center justify-between gap-2 rounded-full bg-hockey-pink px-5 py-3 text-white active:scale-[0.98]" data-id="element-208" data-mp="evwhdhf2seer">
        <span className="text-left leading-tight" data-id="element-209" data-mp="29agzbmc0hvug">
          <span className="block text-[15px] font-extrabold" data-id="element-210" data-mp="2995urkaqsk2a">Quiero dominar los partidos</span>
          <span className="block text-[11px] font-medium text-white/80" data-id="element-211" data-mp="24bnknqkznysp">
            <span className="line-through opacity-70" data-id="element-212" data-mp="3idxpkjip6yd9">€50</span> €20 · pago único
          </span>
        </span>
        <ArrowRightIcon className="h-5 w-5" data-id="element-213" data-mp="3mi5d4ddf689w" />
      </button>
    </div>;
}